import axios from './axiosInstance';



const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetDailyReport=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/reports/daily/`,data)
        .then(response => resolve(response.data))
        .catch((error) => {reject(error.response)})
    })
}

const GetDayOfWeekReport=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/reports/dayofweek/`,data)
        .then(response => resolve(response.data))
        .catch((error) => {reject(error.response)})
    })
}

const GetProductSalesReport=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/reports/productsales/`,data)
        .then(response => resolve(response.data))
        .catch((error) => {reject(error.response)})
    })
}


export {
    GetDailyReport,
    GetDayOfWeekReport,
    GetProductSalesReport
}


